import React, { Component } from 'react';
import { NewAddressModal, ValidationModal } from '../components';

class SelectAddressModal extends Component {
    render() {
        const { ShowFormatInvoiceModal, DelivHouseTools, } = this.props;
        return (
            <div>
                <div className="modal fade" id="selectAddress" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="selectAddressLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                            </div>
                            <div className="modal-body pl-4 pr-4 pb-4 scrollAddress" >
                                
                                {DelivHouseTools && DelivHouseTools.deliveryAddresses.map((address, index) => {
                                    return ( 
                                        <div className="card p-3 mb-4">
                                            <div className='row'>
                                                <div className='col-2 p-3' onClick={() => DelivHouseTools.SetIndexDirection(index)}>
                                                    <input 
                                                        type="radio"
                                                        name="exampleRadios" id="exampleRadios1"
                                                        value="option1"
                                                        checked={DelivHouseTools.setDHIndex === index ? true : false}
                                                        style={{margin:"15px", marginTop:"27px"}}
                                                    />
                                                </div>
                                                <div className='col-8' onClick={() => DelivHouseTools.SetIndexDirection(index)}>
                                                    <label><strong>{`${address.Address ?? ''}.`}</strong></label>
                                                    <p  style={{marginBottom: "2px"}}>
                                                        <strong>{`${address.Street ?? ''}`}</strong>
                                                        <br/>
                                                        {`${address.Block ?? ''}. C.P.: ${address.ZipCode ?? ''} `}
                                                        <br/>
                                                        {`${address.County ?? ''}. ${address.Country ?? ''} `}
                                                        
                                                    </p>
                                                </div>
                                                
                                                <div className='col-2'>

                                                    <i className="fa fa-pencil-square-o pl-4 pr-3 pt-2" aria-hidden="true" data-dismiss="modal" onClick={() => DelivHouseTools.EditAddress(2, true, index)} ></i>

                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                                
                            </div>
                            <div className="modal-footer">
                                <div className="col-sm-12">
                                    <div className="m-2 row">
                                        <button type="button" className="btn-lg btn-secondary col-3 ml-4 mr-3" data-dismiss="modal" >Cancelar</button>
                                        <button type="button" className="btn-lg btn-secondary col-3 mr-3" data-dismiss="modal" onClick={() => DelivHouseTools.NewAddress(1, false)} >Nueva</button>
                                        <button className="btn-lg btn-primary d-block w-100 col-4" type="submit" data-dismiss="modal" data-toggle="modal" data-target="#vmInvoiceDelivery">Continuar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <NewAddressModal
                    DelivHouseTools={DelivHouseTools}
                    isDelivery={false}
                    
                /> */}
                <ValidationModal
                    idValidation="vmInvoiceDelivery"
                    message="¿Va a requerir factura?"
                    button1="Si"
                    button2="No"
                    idModalDestiny="#formatInvoiceModal"
                    idModalOrigin="#formatDeliveryModal"
                    eventOnclick={() => ShowFormatInvoiceModal}
                    eventOnclick2={""}
                />
            </div >
        );
    }
}

export default SelectAddressModal;